/**
 * By default, pino uses pino.stdTimeFunctions.epochTime to
 * generate a timestamp and add it to the `time` field. However,
 * sumologic wants this to be in the `timestamp` field, and it
 * also wants it to be a string.
 * See https://jira.swmdigital.io/browse/PE-578
 */
export function sumoTimestamp() {
    return `,"timestamp":"${Date.now()}"`
}
